import { useQuery } from 'react-query';

import {
  SubscriberProfile,
  fetchSubscriber,
  generateSubscriberKey,
} from '@utils/backend-api/subscriber_directory';

export const SUBSCRIBERS_KEY = 'SUBSCRIBERS_KEY';

interface SubscriberProfileHookProps {
  username: string;
  articlePageId: number | string;
  initialData?: SubscriberProfile;
}

export default function useSubscriberProfile({
  username,
  articlePageId,
  initialData,
}: SubscriberProfileHookProps) {
  const { data: profile, isLoading: isLoadingSubscriberProfile } = useQuery<SubscriberProfile>(
    generateSubscriberKey(username),
    async () => await fetchSubscriber(username, articlePageId),
    { enabled: !initialData, initialData }
  );

  return { profile, isLoadingSubscriberProfile };
}
